<template>
  <div id="mot">
    <div class="columns">
      <div class="column">
        <p class="title has-text-grey-light is-6">Vehicle MOT</p>
      </div>
      <div class="column is-narrow">
        <p class="title is-6">
          <span class="is-valigned" :class="`has-text-${colour}`" v-if="date">
            {{ formatDate(date) }}&nbsp;
          </span>
          <span class="tag is-valigned" :class="`is-${colour}`">
            {{ statusText }}
          </span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDate, yearsDifference } from '@/utils/date.utils.ts'
export default {
  name: 'AutoCheckMot',
  props: {
    data: {
      type: Object,
      required: false,
      default: () => null
    }
  },
  computed: {
    firstMotNotDue() {
      const isNew = yearsDifference(Date.now(), this.data.firstReg) < 3
      return this.status === 'No details held by DVLA' && isNew
    },
    colour() {
      const { status, firstMotNotDue } = this
      if (status === 'Not valid') return 'danger'
      else if (status === 'Valid' || firstMotNotDue) return 'success'
      else return 'warning'
    },
    status() {
      return this.data?.motStatus
    },
    statusText() {
      const { status, firstMotNotDue } = this
      if (!status || status === 'No results returned') return 'Not available'
      else if (firstMotNotDue) return 'First MOT not due'
      else return status
    },
    date() {
      return this.data?.motExpiryDate
    }
  },
  methods: {
    formatDate
  }
}
</script>
